import React, {useEffect, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";

export default function AlertDialog(props) {
    const {onDock} = props;
    const [open,setOpen] = useState(false);
    const [title,setTitle] = useState(null);
    const [message, setMessage] = useState(null);
    const [onOk, setOnOk] = useState(() => () => alert("no onOk set"));
    const show = (title, message, onOk) => {
        setOpen(true);
        setTitle(title);
        setMessage(message);
        setOnOk(() => onOk)
    };

    useEffect(() => {
        onDock(show);
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={() => {
                        setOpen(false);
                        onOk();
                    }} autoFocus color='secondary'>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}